<template>
  <b-nav v-if="navPermissions['reports'].enable">
    <b-nav-item class="d-block-custom" to="/default_home"
    ><i class="fa mr-2 fa-file-invoice text-danger" font-scale="1"></i>Reports
    </b-nav-item>
  </b-nav>
</template>
<script>
import initService from "@/common/api-services/init-service";

export default {
  name: 'top-reports-basic-group',
  components: {},
  data() {
    return {
      isPortalAdminStatus: false,
      isAdminStatus: false,
      groups: [],
      navPermissions: {
        "reports": {
          enable: false,
          role: ["REPORTS_READ", "Administrator"]
        }
      }
    }
  },
  mounted() {
    this.isPortalAdminStatus = initService.getPortalAdminRole();
    this.isAdminStatus = initService.getAdministratorRole() || initService.getPortalAdminRole();
    this.groups = initService.getGroups();
    Object.keys(this.navPermissions).map(item => {
      this.groups.map(it => {
        if (this.navPermissions[item].role.includes(it)) this.navPermissions[item].enable = true;
      });
    });
  }
}
</script>